/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Error } from '../models/error';
import { patchCatalogEntriesBulk } from '../fn/catalog-entries-bulk-update/patch-catalog-entries-bulk';
import { PatchCatalogEntriesBulk$Params } from '../fn/catalog-entries-bulk-update/patch-catalog-entries-bulk';

@Injectable({ providedIn: 'root' })
export class CatalogEntriesBulkUpdateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patchCatalogEntriesBulk()` */
  static readonly PatchCatalogEntriesBulkPath = '/catalog-entries/bulk-update';

  /**
   * Patch Catalog Entries in bulk.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchCatalogEntriesBulk()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchCatalogEntriesBulk$Response(params: PatchCatalogEntriesBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'successResult'?: Array<string>;
'errors'?: Array<Error>;
}>> {
    return patchCatalogEntriesBulk(this.http, this.rootUrl, params, context);
  }

  /**
   * Patch Catalog Entries in bulk.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchCatalogEntriesBulk$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchCatalogEntriesBulk(params: PatchCatalogEntriesBulk$Params, context?: HttpContext): Observable<{
'successResult'?: Array<string>;
'errors'?: Array<Error>;
}> {
    return this.patchCatalogEntriesBulk$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'successResult'?: Array<string>;
'errors'?: Array<Error>;
}>): {
'successResult'?: Array<string>;
'errors'?: Array<Error>;
} => r.body)
    );
  }

}
